var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTrashGrayIcon({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_42075)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.875 3.25H2.79167H10.125",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.20768 3.25033V9.66699C9.20768 9.91011 9.1111 10.1433 8.9392 10.3152C8.76729 10.4871 8.53413 10.5837 8.29102 10.5837H3.70768C3.46457 10.5837 3.23141 10.4871 3.0595 10.3152C2.88759 10.1433 2.79102 9.91011 2.79102 9.66699V3.25033M4.16602 3.25033V2.33366C4.16602 2.09054 4.26259 1.85739 4.4345 1.68548C4.60641 1.51357 4.83957 1.41699 5.08268 1.41699H6.91602C7.15913 1.41699 7.39229 1.51357 7.5642 1.68548C7.7361 1.85739 7.83268 2.09054 7.83268 2.33366V3.25033",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5.08398 5.54199V8.29199",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M6.91602 5.54199V8.29199",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_42075"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11,
    height: 11,
    fill: "white",
    transform: "translate(0.5 0.5)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTrashGrayIcon);
export default __webpack_public_path__ + "static/media/trashGrayIcon.83be8da773c46267404ccf28a64f8e4d.svg";
export { ForwardRef as ReactComponent };